"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userJobPreferencesController = function () {
  function userJobPreferencesController() {
    "ngInject";

    (0, _classCallCheck3.default)(this, userJobPreferencesController);
  }

  (0, _createClass3.default)(userJobPreferencesController, [{
    key: "hasOptedToPrimarySchool",
    value: function hasOptedToPrimarySchool() {
      return this.options.filter(function (o) {
        return o.optionCategoryId === 1020 && o.valueBool;
      }).length > 0;
    }
  }, {
    key: "hasOptedToHighSchool",
    value: function hasOptedToHighSchool() {
      return this.options.filter(function (o) {
        return o.optionCategoryId === 1021 && o.valueBool;
      }).length > 0;
    }
  }]);
  return userJobPreferencesController;
}();

exports.default = userJobPreferencesController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-job-preferences/user-job-preferences.controller.js
 **/